import UserService from '@/services/UserService'

// initial state
const state = {
  currentUser: null
}

// actions
const actions = {
  setCurrentUser ({ commit }, user) {
    commit('SET_CURRENT_USER', user)
  },
  createUser ({ commit, state }, user) {
    commit('SET_CURRENT_USER', user)
    return UserService.create(state.currentUser)
      .then(response => {
        if (response.status === 201) {
          commit('SET_CURRENT_USER', response.data)
          return state.currentUser
        }
        // throw 'Nie można dodać użytkownika: ' + response.data.message
        throw 'Nie można dodać użytkownika: ' + response.data
      }).catch(() => {
        throw 'Nie można dodać użytkownika. Proszę wybrać inną nazwę.'
      })
  },
  updateUser ({ commit, state }) {
    return UserService.update(state.currentUser)
      .then(response => {
        commit('SET_CURRENT_USER', response.data)
        return state.currentUser
      })
  },
  deleteUser ({ commit, state }) {
    const userToDestroy = state.currentUser
    return UserService.destroy(userToDestroy)
      .then(() => {
        commit('SET_CURRENT_USER', null)
        return userToDestroy
      })
  }
}

// mutations
const mutations = {
  SET_CURRENT_USER (state, user) {
    state.currentUser = Object.assign({}, user) // remove reference
  }
}



export default {
  namespaced: true,
  state,
  actions,
  mutations
}